// extracted by mini-css-extract-plugin
module.exports = {"page":"SponsorList_page__rUURL","mainTable":"SponsorList_mainTable__Y_pBV"};